import { DisabledReason } from '@features/shared/components/DisabledReason'
import { PopoverMenu, PopoverMenuRow } from '@features/shared/components/PopoverMenu'
import { CopyIcon, MailIcon, SendIcon, TeamsIcon } from '@features/shared/icons/icons'
import type { ShareActions } from '../hooks/useShareActions'

/**
 * The ways to send a link to what's shared (`page` or `view`), the same in
 * the app's top bar and in a grid's Export menu (whose Link row copies with
 * its own button, so leaves Copy out). Picking one closes the menu first.
 */
export default function ShareMenu({
  noun,
  actions,
  onClose,
  withCopy = true,
}: {
  noun: 'page' | 'view'
  actions: ShareActions
  onClose: () => void
  withCopy?: boolean
}) {
  const run = (action: () => Promise<void>) => () => {
    onClose()
    void action()
  }
  return (
    <PopoverMenu className="w-48">
      {withCopy && (
        <PopoverMenuRow icon={<CopyIcon size={14} />} onClick={run(actions.copyLink)}>
          Copy link to {noun}
        </PopoverMenuRow>
      )}
      <PopoverMenuRow icon={<MailIcon size={14} />} onClick={run(actions.shareByEmail)}>
        Share via email
      </PopoverMenuRow>
      <PopoverMenuRow icon={<TeamsIcon size={14} />} onClick={run(actions.shareInTeams)}>
        Share via Teams
      </PopoverMenuRow>
      <DisabledReason
        reason={actions.canShareAnotherWay ? undefined : "This browser can't share another way."}
        fullWidth
      >
        <PopoverMenuRow
          icon={<SendIcon size={14} />}
          onClick={run(actions.shareAnotherWay)}
          disabled={!actions.canShareAnotherWay}
        >
          Share another way
        </PopoverMenuRow>
      </DisabledReason>
    </PopoverMenu>
  )
}
